/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AmountApiDto } from './amount.model';
import { DateRangeStrApiDto } from './date-range-str.model';
import { PromotionMarketingContentApiDto } from './promotion-marketing-content.model';

export interface QuotesCourseApiDto {
  company?: QuotesCourseApiDto.CompanyEnum;
  code?: string;
  name?: string;
  description?: string;
  thumbnailSmall?: string;
  courseType?: string;
  courseLanguage?: string;
  isFlexible?: boolean;
  productFamily?: string;
  fixedCourseLength?: string;
  fixedCourseLengthNum?: number;
  fixedCourseDateRanges?: Array<DateRangeStrApiDto>;
  schoolCode?: string;
  schoolCountry?: string;
  configType?: string;
  uom?: string;
  minWeeks?: number;
  maxWeeks?: number;
  currency?: string;
  unitPrice?: AmountApiDto;
  endPrice?: AmountApiDto;
  discount?: AmountApiDto;
  packageCode?: string;
  pricelist?: string;
  row?: number;
  /**
   * Custom element weigh. This property is used to define a custom sort order of this element.
   */
  weight?: number;
  courseClassification?: QuotesCourseApiDto.CourseClassificationEnum;
  galleryUrls?: Array<string>;
  descriptionJuniors?: string;
  promotionMarketingContent?: PromotionMarketingContentApiDto;
  lessonsPerWeek?: number;
}
export namespace QuotesCourseApiDto {
  export const CompanyEnum = {
    KIL: 'KIL',
    PL: 'PL',
    ALP: 'ALP',
    ESL: 'ESL',
  } as const;
  export type CompanyEnum = (typeof CompanyEnum)[keyof typeof CompanyEnum];
  export const CourseClassificationEnum = {
    standard: 'standard',
    intensive: 'intensive',
    private_lessons: 'private lessons',
    another_type_of_course_other_than_previous_ones: 'another type of course other than previous ones',
  } as const;
  export type CourseClassificationEnum = (typeof CourseClassificationEnum)[keyof typeof CourseClassificationEnum];
}
